import React from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import { ReuploadForm } from '../ReuploadForm'

const RecordingList = ({ recordings, handleRedirect, placeholder }) => {
  const columns = [
    {
      dataField: 'title',
      text: 'Title',
      align: 'left',
      headerAlign: 'left',
    },
    {
      dataField: 'date',
      text: 'Date',
      align: 'left',
      headerAlign: 'left',
    },
  ]

  const rowStyle = {
    cursor: 'pointer',
  }

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 10,
    lastPageText: '>>',
    firstPageText: '<<',
    nextPageText: '>',
    prePageText: '<',
    showTotal: true,
    alwaysShowAllBtns: true,
  })

  const { SearchBar } = Search
  const hasRecordings = recordings && !!recordings.length

  return (
    <ToolkitProvider keyField="id" data={recordings} columns={columns} search>
      {(props) => (
        <div>
          {hasRecordings && (
            <>
              <SearchBar srText="" {...props.searchProps} />
              <ReuploadForm />
              <br />
            </>
          )}
          <BootstrapTable
            keyField="id"
            data={recordings}
            columns={columns}
            rowEvents={handleRedirect}
            noDataIndication={placeholder || 'No recordings'}
            hover
            bordered={false}
            rowStyle={rowStyle}
            pagination={hasRecordings && pagination}
            {...props.baseProps}
          />
        </div>
      )}
    </ToolkitProvider>
  )
}

export default RecordingList
